<template>
<div>
    <div class="md-layout rows-relatorio">
        <div v-if="permissoes.pagamentosAdministrativoRead || permissoes.pagamentosAdministrativoCanceladoRead ||
        permissoes.admComprasAnaliticoRead || permissoes.admComprasSinteticoRead ||
        permissoes.abastecimentosAdmAnaliticoRead || permissoes.abastecimentosAdmSinteticoRead" 
        class="md-layout-item md-size-100 md-xsmall-size-100">
            <strong class="text-relatorio text-site">ADMINISTRATIVO</strong>
        </div>

        <div v-if="permissoes.pagamentosAdministrativoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'pagamentosAdministrativoRead'}">
                <i class="fas fa-credit-card icon-relatorio text-info"></i>
                <strong class="text-relatorio">PAGAMENTOS</strong>
            </router-link>
        </div>

        <div v-if="permissoes.pagamentosAdministrativoCanceladoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-simple" :to="{name:'pagamentosAdministrativoCanceladoRead'}">
                <i class="fas fa-handshake icon-relatorio text-danger"></i>
                <strong class="text-relatorio">PAGAMENTOS CANCELADOS</strong>
            </router-link>
        </div>

        <div v-if="permissoes.admComprasAnaliticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'admComprasAnaliticoRead'}">
                <i class="fas fa-credit-card icon-relatorio text-info"></i>
                <strong class="text-relatorio">COMPRAS ANALÍTICO</strong>
            </router-link>
        </div>

        <div v-if="permissoes.admComprasSinteticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'admComprasSinteticoRead'}">
                <i class="fas fa-credit-card icon-relatorio text-info"></i>
                <strong class="text-relatorio">COMPRAS SINTÉTICO</strong>
            </router-link>
        </div>
        
        <div v-if="permissoes.abastecimentosAdmAnaliticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'abastecimentosAdmAnaliticoRead'}">
                <i class="fas fa-gas-pump icon-relatorio text-info"></i>
                <strong class="text-relatorio">ABASTECIMENTO ADM ANALÍTICO</strong>
            </router-link>
        </div>

        <div v-if="permissoes.abastecimentosAdmSinteticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-simple" :to="{name:'abastecimentosAdmSinteticoRead'}">
                <i class="fas fa-gas-pump icon-relatorio text-info"></i>
                <strong class="text-relatorio">ABASTECIMENTO ADM SINTÉTICO</strong>
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
};
</script>
